import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { getPortalBasename } from "features/shared/helpers/urlHelper";
import AdminUserState from "infrastructure/store/adminUser/AdminUserState";

// Oidc
import IAppState from "./infrastructure/store/IAppState";
import UserManager from "./infrastructure/oidc/UserManager";
import { USER_FOUND } from "redux-oidc";
import { UserState } from "redux-oidc";

// Styles
import "./styles/main.scss";

// FontAwesome icons
import "./fontawesomeIcons";

// router
import ApplicationRouter from 'features/shared/router/ApplicationRouter';
import {
  isUnathorizedRoute,
} from "features/shared/router/routes/unauthorizedRoutes";


// Menu/Modules routes
import { User } from "oidc-client";
import { useHistory } from "react-router-dom";
import {
  SessionRoute,
  previousRouteKey,
} from "features/shared/models/SessionRoute";

// Chart.js (react-chartjs-2)
import Chart from "chart.js";
import { useAppLocalization } from "infrastructure/localization/useAppLocalization";
require("chart.js/dist/Chart.css"); // basic styles
Chart.platform.disableCSSInjection = true; // disable auto adding styles to head (CSP) 

const App: React.FC = () => {
    // history
  const history = useHistory();

  // store
  const dispatch = useDispatch();
  let userState = useSelector<IAppState, UserState>((store) => store.oidc);
  const adminUser = useSelector<IAppState, AdminUserState>((state) => state.adminUser);

  // localization
  useAppLocalization();

  // side-effects
  useEffect(() => {
    if (!isUnathorizedRoute(history.location.pathname)) {
      getUser();
      saveRouteToSession();
    }
  }, [userState.user]);

  // Pokusím se načíst uživatele z tokenu
  const getUser = async () => {
    if (
      userState.isLoadingUser || // uživatel se načítá
      userState.user || // uživatel je načtený
      window.location.pathname === getPortalBasename("callback") || // probíhá callback z IS
      window.location.pathname === getPortalBasename("logout") // probíhá odhlašování
    ) {
      setAxiosDefaults(userState.user);
      return;
    }

    await UserManager.getUser().then((user) => {
      if (user && !user.expired) {
        setAxiosDefaults(user);
        // nastavim Usera do store
        dispatch({ type: USER_FOUND, payload: { ...user } });
      } else {
        UserManager.signinRedirect();
      }
    });
  };

  // HELPERS
  const setAxiosDefaults = (user?: User) => {
    if (user) {
      // Nastavím token a email do hlavičky axiosu pro všechna volání
      axios.defaults.headers.common["Authorization"] = "Bearer " + user.access_token;

      if (adminUser.isSelectedUser) {
        axios.defaults.headers.common["email"] = adminUser.email;
      } else {
        axios.defaults.headers.common["email"] = user.profile.email;
      }
    }
  };

  /**
   * Uložení routy do session storage.
   * Uložená routa se použije pro správné "přesměrování" po redirectu z IS4.
   */
  const saveRouteToSession = () => {
    const routesBlacklist = ["/", "/callback", "/silent_renew"];
    const route = history.location.pathname;

    if (
      !isUnathorizedRoute(route) &&
      !routesBlacklist.includes(route) &&
      sessionStorage.getItem(previousRouteKey) == null
    ) {
      const prevRoute: SessionRoute = { route: `${route}${history.location.search}`, isUsed: false };
      sessionStorage.setItem(previousRouteKey, JSON.stringify(prevRoute));
    }
  };

  // RENDER
  return <ApplicationRouter />;
};

export default App;
